import type { SyntheticEvent } from 'react';

import type { THandler } from './models';

export const getHandler =
    <T extends SyntheticEvent<HTMLInputElement>>(callback?: THandler<T>) =>
    (event: T) => {
        if (callback) {
            const { name, value } = event.target as HTMLInputElement;

            callback({ value, name, event });
        }
    };
